import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { ITag } from '../model/tags.model';

@Injectable()
export class TagsService extends EntityService<ITag> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'tag',
      urlBackend: configService.backendURL
    });
  }

  /**
   * Pega todas as tags existentes em uma entidade
   * @param domain_id
   * @param entity_name
   * @param pagination
   * @param where
   * @returns
   */
  public getTagsFromEntity(
    domain_id: string,
    entity_name: string,
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    where?: { field: string; value: string }
  ): Observable<any> {
    const url = `${this.baseURL}/get_tags_from_entity`;
    let params = new HttpParams();

    params = params
      .append('domain_id', domain_id)
      .append('entity_name', entity_name);

    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${where.field}`, where.value);
    }

    // {
    //   cliente: { conta_receber_parcelas: IParcelasReceber[] };
    //   pagination: PaginationOptions;
    // }
    return this.http.get<any>(url, { headers: this.getHeader(), params });
  }
}
